<template>
  <div class="tweetStatus">
    <el-button
      size="small"
      @click="tableData.retry(scope.row)"
    >授权</el-button>
    <el-button
      size="small"
      @click="tableData.remove(scope.row,$event)"
      v-if="showButton"
    >删除</el-button>
  </div>
</template>
<script>
export default {
  props: {
    tableData: Object,
    scope: Object
  },
  data() {
    return {};
  },
  computed: {
    getStatus() {
      return "";
    },
    showButton() {
      if (this.tableData.showButton) {
        return this.tableData.showButton(this.scope.row);
      }
      return true;
    }
  },
  watch: {},
  methods: {}
};
</script>
<style lang="scss" scoped>
</style>
